<template>
  <div class="popup-backdrop" v-if="open">
    <div class="popup-card">
      <div class="popup-message">{{ message }}</div>
      <button class="popup-btn" @click="handleDone">Done</button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  open: Boolean,
  message: String,
  onDone: Function,
})
function handleDone() {
  props.onDone()
}
</script>

<style scoped>
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(30, 30, 40, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4000;
}
.popup-card {
  background: #fff;
  border-radius: 13px;
  box-shadow: 0 2px 18px #aaa2;
  padding: 32px 28px 22px 28px;
  min-width: 300px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}
.popup-message {
  font-size: 1.1rem;
  color: #222d3d;
  font-weight: 600;
  text-align: center;
}
.popup-btn {
  padding: 8px 26px;
  border: none;
  border-radius: 7px;
  font-size: 1.02rem;
  cursor: pointer;
  background: #164863;
  color: #fff;
  transition: background 0.16s;
  font-weight: 500;
}
.popup-btn:hover {
  background: #1256a7;
}
</style>
